import React from 'react';
import ImageTextBlockComponent, { type ImageTextBlockComponentProps } from 'content/ImageText';

interface ImageTextBlockProps {
    data: ImageTextBlockComponentProps;
    imageLoading?: 'eager' | 'lazy';
}

const ImageTextBlock: React.FC<ImageTextBlockProps> = ({ data: blockData, imageLoading = 'lazy' }) => (
    <ImageTextBlockComponent {...blockData} imageLoading={imageLoading} />
);
export default ImageTextBlock;
